<template>
    <v-card>
        <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <!-- Edited users-->
        <v-card-text>
            <v-form v-model="isValid">
                <v-container class="py-0">
                    <v-row>
                        <v-col
                            cols="12"
                            md="8"
                        >
                            <v-text-field
                                v-model="editedItem.title.value"
                                class="purple-input"
                                :label="$t('admin.articles.titleAtt')"
                                :error-messages="editedItem.title.error"
                                :rules="[rules.required]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.title.error = ''"
                            />
                        </v-col>
                        <v-spacer />
                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-text-field
                                v-model="editedItem.order.value"
                                class="purple-input"
                                :label="$t('admin.articles.order')"
                                :error-messages="editedItem.order.error"
                                :rules="[rules.required, rules.validNumber]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.order.error = ''"
                            />
                        </v-col>

                        <v-col
                            v-if="isOnlyView"
                            class="py-5"
                            cols="12"
                            md="8"
                        >
                            <label>{{ $t('admin.articles.pageBody') }}</label>
                            <div
                                class="ql-editor"
                                v-html="editedItem.body.value"
                            />
                        </v-col>
                        <v-col
                            v-else
                            cols="12"
                            md="8"
                        >
                            <layout-editor
                                v-model="editedItem.body.value"
                            />
                        </v-col>
                        <v-spacer />
                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-file-input
                                v-model="editedItem.img.value"
                                :label="$t('admin.articles.image')"
                                accept="image/*"
                                :error-messages="editedItem.img.error"
                                :rules="[rules.requiredAtLeastOne]"
                                :disabled="isOnlyView"
                                @change="preview_img(editedItem.img)"
                            />
                            <v-img
                                class="img_preview"
                                :src="editedItem.img.url"
                                max-width="270px"
                                contain
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col
                            cols="12"
                            md="12"
                            class="mt-6"
                        >
                            <v-text-field
                                v-model="editedItem.title2.value"
                                class="purple-input"
                                :label="$t('admin.articles.titleAtt2')"
                                :error-messages="editedItem.title2.error"
                                :rules="[rules.required]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.title2.error = ''"
                            />
                        </v-col>
                        <v-col
                            v-if="isOnlyView"
                            class="py-5"
                            cols="12"
                            md="8"
                        >
                            <label>{{ $t('admin.articles.pageBody2') }}</label>
                            <div
                                class="ql-editor"
                                v-html="editedItem.body2.value"
                            />
                        </v-col>
                        <v-col
                            v-else
                            cols="12"
                            md="8"
                        >
                            <layout-editor
                                v-model="editedItem.body2.value"
                            />
                        </v-col>
                        <v-spacer />
                        <v-col
                            cols="12"
                            md="3"
                        >
                            <v-file-input
                                v-model="editedItem.img2.value"
                                :label="$t('admin.articles.image2')"
                                accept="image/*"
                                :error-messages="editedItem.img2.error"
                                :disabled="isOnlyView"
                                @change="preview_img(editedItem.img2)"
                            />
                            <v-img
                                class="img_preview"
                                :src="editedItem.img2.url"
                                max-width="270px"
                                contain
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer />

            <v-btn
                color="blue darken-1"
                text
                @click="$router.go(-1)"
            >
                {{ $t('common.confirmDialogCancel') }}
            </v-btn>
            <v-btn
                v-if="!isOnlyView"
                color="blue darken-1"
                text
                :disabled="!isValid && !serverCheck"
                @click="save"
            >
                {{ $t('common.dialogSave') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from '@/plugins/axios'
import rules from '@/helpers/rulesValidate'
import { appendRichText } from '@/helpers/richTextField'
import { errorMessageKey } from '@/helpers/apiError'
import LayoutEditor from '@/components/common/form/layoutEditor'

export default {
    components: { LayoutEditor },
    data: function () {
        return {
            urlMain: '/articles',
            rules: {
                ...rules
            },
            item: null,
            editedItem: this.getEditedItem(),
            isValid: true,
            serverCheck: false,
            isOnlyView: false
        }
    },
    computed: {
        formTitle() {
            if (this.item) { return this.isOnlyView ? this.$t('admin.articles.view') : this.$t('admin.articles.edit') } else return this.$t('admin.articles.new')
        }
    },
    created() {
        // console.log(this.item);
        /* console.log('this.$route.params')
        console.log(this.$route.params) */
    },
    /* watch: {
        dialog(val) {
            if (val) {
                this.editedItem = this.getEditedItem()
            }
        }
    }, */
    mounted() {
        this.item = this.$route.params.item ?? null;
    },
    methods: {
        getEditedItem() {
            const item = this.$route.params.item ?? null;

            var empty = !item

            return {
                id: empty ? '' : item.id,
                title: {
                    value: empty ? '' : item.attributes.title,
                    error: ''
                },
                body: {
                    value: empty ? '' : item.attributes.body,
                    error: ''
                },
                title2: {
                    value: empty ? '' : item.attributes.title2,
                    error: ''
                },
                body2: {
                    value: empty ? '' : item.attributes.body2,
                    error: ''
                },
                order: {
                    value: empty ? '' : item.attributes.order,
                    error: ''
                },
                img: {
                    value: empty || !item.attributes.image1 ? [] : new File(
                        [item.attributes.image1],
                        item.attributes.image1,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: empty || !item.attributes.image1 ? ""
                        : process.env.VUE_APP_API_ENDPOINT + 'imagesSimple?filename=articles/images/' + item.attributes.image1
                },
                img2: {
                    value: empty || !item.attributes.image2 ? [] : new File(
                        [item.attributes.image2],
                        item.attributes.image2,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: empty || !item.attributes.image2 ? ""
                        : process.env.VUE_APP_API_ENDPOINT + 'imagesSimple?filename=articles/images/' + item.attributes.image2
                },
                url: {
                    value: empty ? '' : item.attributes.url,
                    error: ''
                }
            }
        },
        preview_img(img) {
            if (img.value && !(img.value instanceof Array)) {
                img.url = URL.createObjectURL(
                    img.value
                );
            } else {
                img.url = null;
                img.value = [];
            }
        },
        initialize() {

        },
        async save() {
            const formData = new FormData();
            formData.append("title", this.editedItem.title.value);
            // Los cuerpos van como parte de fichero, no como campo: ver richTextField.js.
            appendRichText(formData, "body", this.editedItem.body.value);

            formData.append("title2", this.editedItem.title2.value);
            appendRichText(formData, "body2", this.editedItem.body2.value);

            formData.append("image1", this.editedItem.img.value);
            formData.append("image2", this.editedItem.img2.value);
            /* formData.append("image3", this.editedItem.img3.value); */

            formData.append("url", this.editedItem.url.value);
            formData.append("order", this.editedItem.order.value);

            let urlAppend = ''
            let method = 'POST'
            if (this.editedItem.id) {
                urlAppend = '/' + this.editedItem.id
                method = 'PATCH'

                formData.append("_method", method);
            }

            /* console.log('********** formData ********')
            console.log(formData) */

            try {
                const result = await axios
                    .post(this.urlMain + urlAppend, formData, {
                        headers: { "Content-Type": "multipart/form-data" }
                    });

                /* const result = await axios({
                    method: method,
                    url: this.urlMain + urlAppend,
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" }

                }) */

                /* console.log('********** result ********')
                console.log(result) */

                if (result.status === 200 || result.status === 201 || result.status === 204) {
                    this.viewPost(result.data.article)

                    const actionMSG = this.editedItem.id ? 'updatedOK' : 'createdOK'
                    this.$store.dispatch('snackbar/success', this.$t('common.' + actionMSG))
                }
            } catch (error) {
                /* console.log('********** errors ********')
                console.log(error) */

                if (error?.response?.status === 422) {
                    if (error.response?.data?.errors?.length) {
                        // e.source solo viene en los errores del propio JSON:API; los de
                        // validación de Laravel llegan sin él y esto reventaba dentro
                        // del catch, dejando al usuario sin ningún aviso.
                        error.response.data.errors.forEach((e) => {
                            if (e?.source?.pointer === '/data/attributes/title') {
                                this.editedItem.title.error = e.detail
                            }
                            if (e?.source?.pointer === '/data/attributes/body') {
                                this.editedItem.body.error = e.detail
                            }
                        })
                    }
                }

                this.$store.dispatch('snackbar/error', this.$t(errorMessageKey(error)))
            }
        },
        viewPost(item) {
            this.isOnlyView = true;

            this.editedItem = {
                id: item.id,
                title: {
                    value: item.title,
                    error: ''
                },
                body: {
                    value: item.body,
                    error: ''
                },
                title2: {
                    value: item.title2,
                    error: ''
                },
                body2: {
                    value: item.body2,
                    error: ''
                },
                order: {
                    value: item.order,
                    error: ''
                },
                img: {
                    value: new File(
                        [item.image1],
                        item.image1,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: this.editedItem.img.url
                },
                img2: {
                    value: new File(
                        [item.image2],
                        item.image2,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: this.editedItem.img2.url
                },
                url: {
                    value: item.url,
                    error: ''
                }
            }
        }
    }
}
</script>

<style >
/*iframe.ql-video {
  width: 500px !important;
  height: 500px !important;
}*/

.quill-editor iframe {
  pointer-events: none;
}

</style>
